import { lazyImport } from '../LazyImportComponent';

/* This is only in a separate file because lazyImport
 * is incredibly difficult to mock accurately for tests,
 * whereas mocking this entire getLoginModal function is easy
 */
const getLoginModal = lazyImport(
    () =>
        import(
            /* webpackChunkName: "loginmodal", webpackPrefetch: 40 */ '@zocdoc-frontend-common/components-log-in-modal'
        ),
    'LoginModal'
);

export default getLoginModal;
